<template lang="pug">
  div.page--compare.page
    page-header.page-header--compare(
      :breadcrumb-only="true"
      header-class="page-header--compare text-center"
      :page-title="trans('labels.frontend.compare.compare')"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .container-fluid
      .row.align-items-center
        .col
          h2.compare-page__title {{ trans('labels.frontend.compare.compare') }}
        .col.text-right
          .compare-page__empty(@click.prevent="empty()" v-if="items.length > 0")
            font-awesome-icon.mr-2(:icon="['far', 'trash-alt']")
            span {{ trans('labels.frontend.compare.delete_all') }}
      .row.mb-5(v-if="items.length === 0")
        .col.text-center
          p {{ trans('labels.frontend.compare.no_product') }}
      .row(v-if="items.length > 0")
        .col
          .table-responsive
            table.table.table--compare-table
              thead
                tr
                  th
                  th(v-for="product in products")
                    .product-list
                      product-list-item.col-12(
                        :product="product" :key="product.id" type="vertical"
                      )
                      .col.text-right
                        .compare-page__empty(@click.prevent="remove(product)")
                          font-awesome-icon.mr-2(:icon="['far', 'trash-alt']")
                          span ลบ
              tbody
                tr(v-for="column in config.table.columns" v-if="config.table.columns")
                  td {{ getSpecLabelByKey(column) }}
                  td(v-for="product in products")
                    | {{ product.specs[column] }}
</template>

<script>
  import ProductCategorySpecs from "../shop/product/ProductCategorySpecs";
  import PageHeader from "../../components/layouts/PageHeader";
  import BreadcrumbsManager from "../../mixins/BreadcrumbsManager";
  import ProductListItem from "../../components/product/ProductListItem";
  import {RepositoryFactory} from "../../repositoryFactory";
  import notify from "../../components/notify";

  const ProductRepository = RepositoryFactory.get('product');

  export default {
    mixins: [BreadcrumbsManager],
    components: {
      PageHeader,
      ProductListItem
    },
    metaInfo() {
      return {
        title: Lang.get('labels.frontend.compare.compare')
      }
    },
    data() {
      return {
        items: [],
        products: [],
        config: {
          table: {
            columns: []
          }
        }
      }
    },
    created() {
      this.items = this.$store.getters['compare/items'];
    },
    mounted() {
      this.setBreadcrumbs([
        { name: Lang.get('labels.frontend.compare.compare') },
      ]);

      this.getProducts();
    },
    methods: {
      remove(item) {
        this.$store.dispatch('compare/remove', item);
        this.getProducts();
      },
      empty() {
        this.$store.dispatch('compare/empty');
        this.getProducts();
      },
      async getProducts() {
        this.products = [];
        try {
          const productIds = _.map(this.items, 'item_code');
          if (productIds.length > 0) {
            const {data} = await ProductRepository.get({where_in: productIds}).then(resp => resp.data);
            this.products = data;
            this.config = {
              ...this.config,
              ...{
                table: {
                  columns: Object.keys(data[0].specs)
                }
              }
            }
          }
        } catch (e) {
          notify.errors(this, e);
        }
      },
      getSpecLabelByKey(key) {
        const category = _.uniq(_.map(this.products, 'main_category'));
        if (typeof category !== 'undefined') {
          if (typeof ProductCategorySpecs[category[0]] !== 'undefined') {
            if (typeof ProductCategorySpecs[category[0]].labels[key] !== 'undefined') {
              return ProductCategorySpecs[category[0]].labels[key];
            }
          }
        }
        return key.replace("_", " ");
      },
    }
  }
</script>
